<template>
  <div>
    <el-upload
      action
      :accept="accept.toString()"
      :limit="limit"
      ref="upload"
      :file-list="fileList"
      :http-request="uploadRequest"
      :on-remove="handleRemove"
      :class="{ hide: fileList.length >= limit || disabled, mini: isMini }"
      :on-success="handleUploadSuccess"
      :on-error="handleError"
      :on-change="handleUploadChange"
      :before-upload="uploadBefore"
      list-type="picture-card"
      :on-progress="handleProgress"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          alt=""
        />
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
      <div v-if="!disabled" slot="tip" class="el-upload__tip">
        {{ computedTips }}
      </div>
    </el-upload>
    <el-progress v-if="progressFlag" :percentage="progress" />

    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="previewFileList"
      :initialIndex="initialIndex"
    />
  </div>
  
</template>

<script>
import ElImageViewer from "./image-viewer";
import oss from "../../assets/js/ali-oss";
import { getUrls } from '@/assets/js/util'

export default {
  name: 'Upload',
  components: { ElImageViewer },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: () => ['.jpeg', '.jpg', '.png']
    },
    limit: {
      type: Number,
      default: 3
    },
    maxSize: {
      type: Number,
      default: 5
    },
    action: {
      type: String,
      default: ''
    },
    isMini: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.fileList = newVal.map(item => {
            // Ensure the item has required properties
            if (typeof item === 'string') {
              return { url: item };
            }
            return item;
          });
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      hideUpload: false,
      fileList: [],
      showViewer: false,
      initialIndex: 0,
      previewFileList: [],
      progressFlag: false,
      progress: 0
    }
  },
  computed: {
    computedTips() {
      return `支持${this.accept.map(n=> n.slice(1).toUpperCase()).join('、')}格式`
    },
    classStr() {
      return this.size
    }
  },
  methods: {
    setFileList(images) {
      this.fileList = images.map(n=> ({url: n}))
    },
    uploadRequest(option) {
      oss.ossUploadFile(option);
    },
    handleRemove(file, fileList) {
      const newVal = this.value.filter(item=> item.url !== file.url)
      this.$emit('input', newVal);
      this.$emit('remove', file, fileList);

      // let fileList = this.$refs.upload.uploadFiles;
      // let index = fileList.findIndex((fileItem) => {
      //   return fileItem.uid === file.uid;
      // });
      // if(index > -1) {
      //   fileList.splice(index, 1);
      //   let updateImages = [...this.images]
      //   updateImages.splice(index, 1)
      //   this.$emit("update:images", updateImages)        
      // }
    },
    handleUploadSuccess(res, file, fileList) {
      // Update parent component
      this.$emit('input', fileList);
      this.$emit('success', res, file, fileList);
      // let updateImages = [...this.images, res];
      // this.$emit("update:images", updateImages)
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList, 'handleError')
      this.$emit('error', err, file, fileList);
    },
    handleUploadChange(file, fileList) {
      // this.hideUpload = fileList.length >= this.limit;
    },
    uploadBefore(file) {
      const isLt = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt) {
        this.$message.error(`上传的图片大小不能超过${this.maxSize}MB!`);
        return false;
      }
      const isAcceptOk = this.accept.some((n) => file.name.endsWith(n));
      if(!isAcceptOk) {
        this.$message.error(`上传的图片大小格式必须为${this.accept.map(n=> n.slice(1).toUpperCase()).join('、')}`);
        return false;
      }
    },
    handleProgress(event, file, fileList) {
      this.progressFlag = true;
      this.progress = parseInt(event.loaded / event.total * 100);
      if(this.progress >= 100) {
        this.progress = 100;
        setTimeout(() => {
          this.progressFlag = false;
        }, 500);
      }
    },
    handlePictureCardPreview(file) {
      this.previewFileList = getUrls(this.fileList);
      this.initialIndex = this.previewFileList.findIndex(
        (item) => (item == file.url ||  item == file.response)
      );
      this.showViewer = true;
    },
    closeViewer() {
      this.showViewer = false;
    },
  }
}
</script>

<style scoped>
::v-deep .hide .el-upload--picture-card {
  display: none;
}

::v-deep .mini .el-upload-list__item {
  width: 60px !important;
  height: 60px !important;
}


/* .el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
} */

.el-image-viewer__btn .el-icon-circle-close {
  color: #fff;
}
</style>